import React from 'react'
import { useAppDispatch } from '../../Store';
import { FormAction } from '../../Store/FormConfig/form.actions';
import styled from 'styled-components';
import { LoaderComponentProps, withLoader } from '../../AppComponents/AppLoader/LoaderComponent';
const { useLocation } = require("react-router-dom");


interface ReportCardProps extends LoaderComponentProps { }
const ReportCard: React.FC<ReportCardProps> = ({ setLoading }) => {
    const dispatch = useAppDispatch();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const applicationFormId = searchParams.get("id");
    const [reportCardUrl, setReportCardUrl] = React.useState("")
    const [isReportCardLoading, setIsReportCardLoading] = React.useState(false);    
    React.useEffect(() => {
        if (applicationFormId) {
            setIsReportCardLoading(true)
            setLoading(true)
            dispatch(FormAction.reportCardAction(applicationFormId))
                .then((res: any) => {
                    const reportCardUrl = res?.payload?.data?.data?.report_card_url;
                    setLoading(false)
                    setIsReportCardLoading(false)
                    setReportCardUrl(reportCardUrl);
                })
                .catch((error: any) => {
                    setLoading(false)
                    setIsReportCardLoading(false)
                    console.error(error);
                });
        } else {
            setLoading(false)
            setIsReportCardLoading(false)
            console.warn('paramID is invalid:', applicationFormId);
        }
        return () => {
            setReportCardUrl("");
            setIsReportCardLoading(false);
        }
    }, [applicationFormId]); // eslint-disable-line react-hooks/exhaustive-deps


    const handleDownload = () => {
        if (reportCardUrl) {
            window.open(reportCardUrl, '_blank');
        }
    };

    return (
        <PdfContainer>
            {isReportCardLoading ? "Loading..." : (
                <div className="col-lg-12">
                    <div className="card">
                        <div className='btn-container'>
                            <h6>
                                Report Card
                            </h6>
                            {reportCardUrl && (
                                <button className='btn btn-danger' style={{}} onClick={handleDownload}>
                                    <i className="fa fa-file-pdf-o" aria-hidden="true" style={{ marginRight: "8px" }}></i>
                                    Download PDF
                                </button>
                            )}
                        </div>

                        {reportCardUrl ? <iframe
                            title="PDF Viewer"
                            src={`https://docs.google.com/viewer?url=${encodeURIComponent(reportCardUrl)}&embedded=true`}
                            style={{ width: '100%', height: 'calc(100% - 40px)', border: "0px" }}
                        >
                            <p>Your browser does not support iframes.</p>
                        </iframe> : <div style={{ textAlign: "center" }}>
                            <h3>No Report Card To Display</h3>
                        </div>
                        }
                    </div>
                </div>
            )}
        </PdfContainer>
    )
}

export default withLoader(ReportCard);


const PdfContainer = styled.div`
    .btn-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px;
      h6 {
      margin: 0;
      }
    }
      .card {
          height: calc(100vh - 102px);
          padding: 0px 16px;
          overflow: hidden;
          padding-bottom: 16px;
          margin: 0px;
      }
    height: calc(100vh - 86px);
    overflow: hidden;
    margin: 0px;
    margin-top: 21px;
    .pdf-container {
      height: 100%;
    }
`;
